// extracted by mini-css-extract-plugin
export default {"deleteButton":"ReportDelete_deleteButton__p0msL","warningModal":"ReportDelete_warningModal__+YG03","buttonBlock":"ReportDelete_buttonBlock__O1I-g"};